import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const RouteNotFound = () => {
    const [t] = useTranslation();
    return (
        <div className='card mb-3 w-50 m-auto rounded-0'>
            <div className="card-header text-white bg-dark">
                404
            </div>
            <div className="card-body">
                <p>{t("page_not_found")}</p>
                <Link to="/" className='btn btn-outline-primary'>{t("main")}</Link>
            </div>
        </div>
    )
}

export default RouteNotFound;